import * as dayjs from 'dayjs';
import {ContactFieldPreset} from './contact-field-preset';

export class ContactType {

    id: string;
    name: string;
    contact_field_preset_id: string;
    sorting: number;
    is_order_invoice: boolean;
    is_order_delivery: boolean;
    is_order_meta: boolean;
    is_order_sender: boolean;
    modified: dayjs.Dayjs;
    created: dayjs.Dayjs;

    contact_field_preset: ContactFieldPreset;

    constructor() {
    }

    static fromJSON(json: ContactTypeJSON | string): ContactType {
        if (typeof json === 'string') {
            return JSON.parse(json, ContactType.reviver);
        } else {
            const contactType = Object.create(ContactType.prototype);

            const extra = {
                modified: dayjs(json.modified),
                created: dayjs(json.created),
                contact_field_preset: null
            };

            Object.keys(json).forEach((key, _) => {
                if (key === 'contact_field_preset' && json[key]) {
                    extra[key] = ContactFieldPreset.fromJSON(json[key]);
                }
            });

            return Object.assign(contactType, json, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === "" ? ContactType.fromJSON(value) : value;
    }
}

// A representation of ContactType data that can be converted to
// and from JSON without being altered.
interface ContactTypeJSON {
    id?: string;
    name?: string;
    contact_field_preset_id?: string;
    sorting?: number;
    is_order_invoice?: boolean;
    is_order_delivery?: boolean;
    is_order_meta?: boolean;
    is_order_sender?: boolean;
    modified?: dayjs.Dayjs;
    created?: dayjs.Dayjs;
    contact_field_preset?: ContactFieldPreset;
}
